"use strict";

exports.__esModule = true;
exports["default"] = exports.BackgroundContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _components = require("../../components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BackgroundContainer = (0, _styledComponents["default"])(_components.Background).withConfig({
  displayName: "mobile-footer__BackgroundContainer",
  componentId: "sc-o4871l-0"
})(["z-index:1;position:absolute;bottom:0;cursor:pointer;"]);
exports.BackgroundContainer = BackgroundContainer;
var propTypes = {
  applyOnClick: _propTypes.func.isRequired,
  className: _propTypes.string,
  htmlId: _propTypes.string
};
var defaultProps = {
  className: "",
  htmlId: ""
};

var MobileFooter = function MobileFooter(_ref) {
  var applyOnClick = _ref.applyOnClick,
      className = _ref.className,
      htmlId = _ref.htmlId;
  return /*#__PURE__*/_react["default"].createElement(BackgroundContainer, {
    backgroundColor: "blue",
    className: className,
    display: ["flex", "flex", "none"],
    forwardedAs: "section",
    height: "60px",
    id: htmlId,
    onClick: applyOnClick,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    justifyContent: "center",
    px: [3, 5, 5, 130],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_components.Heading, {
    color: "white",
    display: "flex",
    fontSize: 3,
    fontWeight: 2,
    lineHeight: [2, 2, 1, 1, 1, 1],
    mb: 0
  }, "Apply")));
};

MobileFooter.propTypes = propTypes;
MobileFooter.defaultProps = defaultProps;
MobileFooter.displayName = "Modules.MobileFooter";
var _default = MobileFooter;
exports["default"] = _default;